<button class="mat-elevation-z2 no-reports-info"
        mat-icon-button (click)="noReportsInfo()"><mat-icon>info</mat-icon></button>
